module.exports = __webpack_public_path__ + "static/rotate-your-device-8ae090970a326bd4b0b26c2ed069c3ce.jpg";